import Vue from 'vue'
import VueRouter from "vue-router"
import App from './App.vue'
import PaintingApps from './Pages/AppBriefs/PaintingApps.vue'
import DataStructs from './Pages/AppBriefs/DataStructs.vue'
import IconMakerApp from './Pages/AppBriefs/IconMakerApp.vue'
import GraphEditor from './Pages/AppBriefs/GraphEditor.vue'
import GraphEditorUserPolicyEn from './Pages/Policies/GraphEditorUserPolicyEn.vue'
import GraphEditorUserPolicyZh from './Pages/Policies/GraphEditorUserPolicyZh.vue'
import GraphEditorUserUsageEn from './Pages/Policies/GraphEditorUserUsageEn.vue'
import GraphEditorUserUsageZh from './Pages/Policies/GraphEditorUserUsageZh.vue'
import PaintingAppUserPolicy from './Pages/Policies/PaintingAppUserPolicy.vue'
import DatastructsAppUserPolicy from './Pages/Policies/DatastructsAppUserPolicy.vue'
import IconMakerUserPolicy from './Pages/Policies/IconMakerUserPolicy.vue'

Vue.config.productionTip = false
Vue.use(VueRouter)

const routes = [
  { path: '/paintingapps', component: PaintingApps },
  { path: '/datastructs', component: DataStructs },
  { path: '/iconmaker', component: IconMakerApp },
  { path: '/grapheditor', component: GraphEditor },
  { path: '/grapheditorpolicyen', component: GraphEditorUserPolicyEn },
  { path: '/grapheditorpolicyzh', component: GraphEditorUserPolicyZh },
  { path: '/grapheditoruserusageen', component: GraphEditorUserUsageEn },
  { path: '/grapheditoruserusagezh', component: GraphEditorUserUsageZh },
  { path: '/paintingpolicy', component: PaintingAppUserPolicy },
  { path: '/datastructpolicy', component: DatastructsAppUserPolicy },
  { path: '/iconmakerpolicy', component: IconMakerUserPolicy },
  { path: '/policy', redirect: '/paintingpolicy' },
  { path: '/', redirect: '/paintingapps' }
]

const router = new VueRouter({
  routes // routes: routes
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
